<ng-container>
  <div
    class="dropdown-container"
    [ngClass]="{
      'padding-child': parentItem.level > 0,
      'menu-not-expanded': !parentItem.expanded
    }">
    <div class="header" *ngIf="!parentItem.expanded && parentItem.level === 0">
      <ui-fh-text [type]="'TEXT'" [class]="'fw-bold'" [text]="parentItem.title | translate"></ui-fh-text>
    </div>
    <div class="content z-0">
      <ui-fh-menu-item
        *ngFor="let item of items | fhMenuFeatures : validateFeatures; let i = index"
        [item]="item"
        [isDropdown]="true"
        [isLastItemDropdown]="(items | fhMenuFeatures : validateFeatures).length - 1 == i"
        (itemClicked)="onItemClicked()"></ui-fh-menu-item>
    </div>
  </div>
</ng-container>
